import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import api, { API_URL } from "../services/api";

import "../styles/examDetails.css";

function ExamDetails() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [exam, setExam] = useState(null);
  const [relatedExams, setRelatedExams] = useState([]);

  useEffect(() => {

    const fetchRelated = async (categoryName) => {

      try {

        const response = await api.get("/exams");

        const related = response.data
          .filter(
            (item) =>
              item.category === categoryName &&
              item.id !== Number(id)
          )
          .slice(0, 4);

        setRelatedExams(related);

      } catch (error) {

        console.error(error);

      }

    };

    const fetchExam = async () => {

      try {

        const response = await api.get(`/exams/${id}`);

        setExam(response.data);

        fetchRelated(response.data.category.name);

      } catch (error) {

        console.error(error);

      }

    };

    fetchExam();

  }, [id]);

  const handleFreeDownload = async () => {

    const result = await Swal.fire({
      title: "Download Free Exam?",
      text: exam.title,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Download",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#021658"
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: "Preparing Download...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {

      const response = await api.get(
        `/downloads/free/${exam.id}`
      );

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Download Ready",
        text: "Your download is starting.",
        timer: 1500,
        showConfirmButton: false
      });

      window.open(
        `${API_URL}${response.data.file_url}`,
        "_blank"
      );

    } catch (error) {

      Swal.close();

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text:
          error.response?.data?.message ||
          "Unable to download exam."
      });

    }

  };

  const handleBuyNow = () => {

    navigate(`/payment/${exam.id}`);

  };

  if (!exam) {

    return (
      <>
        <ClientNavbar />

        <h2
          style={{
            textAlign: "center",
            margin: "80px"
          }}
        >
          Loading...
        </h2>

        <Footer />
      </>
    );

  }

  return (

    <>
      <ClientNavbar />

      <div className="exam-details">

        <div className="exam-main">

          <div className="exam-image">

            <img
              src={
                exam.thumbnail_url
                  ? `${API_URL}${exam.thumbnail_url}`
                  : "https://via.placeholder.com/600x350?text=CompExams"
              }
              alt={exam.title}
            />

          </div>

          <div className="exam-info">

            <span className="badge">
              {exam.category.name}
            </span>

            <h1>{exam.title}</h1>

            <p>{exam.description}</p>

            <div className="price-box">

              {exam.is_free ? (

                <span className="free">
                  FREE
                </span>

              ) : (

                <span className="paid">
                  KES {exam.price}
                </span>

              )}

            </div>

            {exam.is_free ? (

              <button
                className="download-btn"
                onClick={handleFreeDownload}
              >
                Download Free Exam
              </button>

            ) : (

              <button
                className="buy-btn"
                onClick={handleBuyNow}
              >
                Buy Now
              </button>

            )}

          </div>

        </div>

        <section className="related-section">

          <h2>Related Exams</h2>

          <div className="related-grid">

            {relatedExams.map((item) => (

              <div
                key={item.id}
                className="related-card"
              >

                <h3>{item.title}</h3>

                <p>{item.category}</p>

                <Link
                  to={`/exam/${item.id}`}
                >
                  View
                </Link>

              </div>

            ))}

          </div>

        </section>

      </div>

      <Footer />

    </>

  );

}

export default ExamDetails;